import React from 'react';
export function DiscoverySection() {
  const ingredients = [{
    name: 'Cinnamon Bark',
    singleRating: 3,
    combinedRating: 5
  }, {
    name: 'Bitter Melon',
    singleRating: 2,
    combinedRating: 5
  }, {
    name: 'Mulberry Leaf',
    singleRating: 3,
    combinedRating: 5
  }, {
    name: 'Juniper Berry',
    singleRating: 2,
    combinedRating: 5
  }];
  return <section className="mb-16 bg-white rounded-lg shadow-md p-8" data-id="element-27">
      <h2 className="text-2xl md:text-3xl font-bold text-emerald-800 mb-6" data-id="element-28">
        My Discovery
      </h2>
      <div className="text-gray-700 mb-8" data-id="element-29">
        <p className="mb-4" data-id="element-30">
          Even with all these positive changes, I still faced a significant
          challenge. Sourcing those four key ingredients—cinnamon bark, bitter
          melon, mulberry leaf, and juniper berry—was expensive and
          time-consuming.
        </p>
        <p className="mb-4" data-id="element-31">
          I was spending nearly $400 monthly on supplements, juggling multiple
          bottles, and constantly researching proper dosages. It simply wasn't
          sustainable.
        </p>
        <p className="mb-4" data-id="element-32">
          That's when I discovered a daily support supplement that combined all
          four ingredients in one formula, in the precise ratios that research
          suggested were most effective.
        </p>
        <p className="mb-4" data-id="element-33">
          The difference was remarkable. Not only was it more affordable and
          convenient, but the combination of ingredients seemed to work better
          together than they had individually.
        </p>
      </div>
      <div className="mb-8" data-id="element-34">
        <div className="flex items-center justify-between mb-4" data-id="element-35">
          <h3 className="text-xl font-semibold text-emerald-700" data-id="element-36">
            Ingredient Effectiveness Comparison
          </h3>
          <div className="flex items-center" data-id="element-37">
            <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-emerald-300 shadow-sm" data-id="element-38">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/svbhRAzn96SZdeoKevRMth/martha-high5.jpg" alt="Martha's personal review" className="w-full h-full object-cover" data-id="element-39" />
            </div>
            <span className="ml-2 text-sm text-emerald-700 font-medium" data-id="element-40">
              Martha's
              <br data-id="element-41" />
              Personal Review
            </span>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-42">
          <table className="min-w-full" data-id="element-43">
            <thead data-id="element-44">
              <tr className="bg-emerald-100" data-id="element-45">
                <th className="px-4 py-2 text-left text-emerald-800" data-id="element-46">
                  Ingredient
                </th>
                <th className="px-4 py-2 text-left text-emerald-800" data-id="element-47">
                  As Single Ingredient
                </th>
                <th className="px-4 py-2 text-left text-emerald-800" data-id="element-48">
                  In Combined Formula
                </th>
              </tr>
            </thead>
            <tbody data-id="element-49">
              {ingredients.map((ingredient, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-50">
                  <td className="px-4 py-3 border-t border-gray-200" data-id="element-51">
                    {ingredient.name}
                  </td>
                  <td className="px-4 py-3 border-t border-gray-200" data-id="element-52">
                    <div className="flex" data-id="element-53">
                      {[...Array(5)].map((_, i) => <svg key={i} className={`w-5 h-5 ${i < ingredient.singleRating ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-54">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-55" />
                        </svg>)}
                    </div>
                  </td>
                  <td className="px-4 py-3 border-t border-gray-200" data-id="element-56">
                    <div className="flex" data-id="element-57">
                      {[...Array(5)].map((_, i) => <svg key={i} className={`w-5 h-5 ${i < ingredient.combinedRating ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20" data-id="element-58">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-59" />
                        </svg>)}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <p className="text-sm text-gray-500 mt-2" data-id="element-60">
          Based on my personal experience and response over 6 months
        </p>
      </div>
      <div className="text-gray-700" data-id="element-61">
        <p className="mb-4" data-id="element-62">
          Within weeks of switching to this combined formula, I noticed more
          consistent energy throughout the day, fewer cravings, and most
          importantly, steadier blood sugar readings.
        </p>
        <p className="mb-4" data-id="element-63">
          My doctor was surprised at my next checkup. "Whatever you're doing,"
          he said, "keep doing it." For the first time in decades, I felt like I
          was truly managing my condition instead of it managing me.
        </p>
      </div>
    </section>;
}